import React from "react";
import { TableHead as TableHead$1 } from "@mui/material";
import { makeStyles } from "tss-react/mui";
const useStyles = makeStyles()((theme) => ({
  tableHeadSingleLine: {
    whiteSpace: "nowrap"
  },
  tableHeadSecondary: {
    color: theme.palette.text.secondary
  }
}));
function TableHead({ children, variant = "primary", singleLine }) {
  const { classes, cx } = useStyles();
  return /* @__PURE__ */ React.createElement(
    TableHead$1,
    {
      className: cx({
        [classes.tableHeadSingleLine]: singleLine,
        [classes.tableHeadSecondary]: variant === "secondary"
      })
    },
    children
  );
}
export {
  TableHead
};
//# sourceMappingURL=TableHead.js.map
